import React, {
  Suspense, useEffect, useCallback,
} from 'react';
import { useLocation } from 'react-router';
import { connect } from 'react-redux';

import { CacheProvider } from '@emotion/react';
import {
  Footer,
  Header,
  Loader,
} from 'components';
import Amplitude from 'lib/amplitude';
import trackingService from 'services/TrackingService';
import { resetUIState } from 'resources/ui/ducks';
import ErrorReporter from 'components/ErrorReporter';
import emotionCache from './lib/emotionCache';
import 'assets/stylesheets/styles.css';
import Routes from './routes';
import initAmplitudeSurveys from './amplitudeSurveys';
import 'app.css';

/*
Introduced this AppWrapper to fix the sticky footer that was snot working in IE11.
*/

export const App = ({ dispatch }) => {
  const location = useLocation();

  const onRouteChange = useCallback(() => {
    trackingService.trackPageView();
    dispatch(resetUIState());
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      await trackingService.init();
      initAmplitudeSurveys();
      if (typeof window !== 'undefined') window.amplitude = await Amplitude.init(); // create the shared instance
    })();
  }, []);

  useEffect(() => {
    onRouteChange();
  }, [location, onRouteChange]);

  const currentYear = new Date().getUTCFullYear().toString();

  return (
    <CacheProvider value={emotionCache}>
      <div className="app-wrapper">
        <div className="styled-app">
          <Header />
          <div className="outer-section">
            <ErrorReporter>
              <div className="styled-main">
                <Suspense fallback={<Loader />}>
                  <Routes />
                </Suspense>
              </div>
            </ErrorReporter>
          </div>
          <Footer currentYear={currentYear} />
        </div>
      </div>
    </CacheProvider>
  );
};

const mapStateToProps = () => ({});

const ConnectedApp = connect(mapStateToProps)(App);

export default ConnectedApp;
